module.exports = __webpack_public_path__ + "static/media/worth.85fbf7df.png";